
import {
  openNoAddressPop,
  formatWareImgUrl,
  noAddressCheck,
  getStockMax,
  getDeliveryMethod,
  priceFormatOther
} from "../../utils/utils"
import { handleAddToCartV2 } from "../../utils/cartResponse"
import inputNumber from "@/components/cms/inputNumber.vue"
import emptyImg from "@/assets/images/empty_img.png"
import yuuAppLogo from "@/assets/images/yuu_price_tag.png"
import addCartImg from "@/assets/images/addCart.png"
import disabledCart from "@/assets/images/disabledCart.png"
import lazyImg from "@/components/cms/lazyImg.vue"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"
import { omnichatAddToCart } from "@/utils/omnichat"
import EllipsisItemList from "@/components/ellipsisItemList.vue"
export default {
  name: "CmsWare",
  components: {
    inputNumber,
    lazyImg,
    EllipsisItemList
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    },
    styleConfig: {
      type: Object,
      default: () => {}
    },
    pageFrom: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      clearInterval: null,
      previewImg: yuuAppLogo,
      addCart: addCartImg,
      disabledCart,
      items: [],
      promoContainer: null,
      itemElements: [],
      configs: {},
      commonReqParams: {},
      deliveryMethod: "homeDelivery"
    }
  },
  computed: {
    imageUrl() {
      const imgUrl = this.configs.spImgUrl
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      const { skuId, sku, name } = this.configs?.additional || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${skuId || sku}&name=${encodeURIComponent(
        name
      )}`
    },
    findSimilarLink() {
      const { skuId, sku } = this.configs?.additional || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${skuId || sku}`
    }
  },
  watch: {
    configData: {
      handler(newVal) {
        // 聚合首页下发商品携带门店商家
        if (newVal?.venderId && newVal?.storeId) {
          newVal.additional.venderId = newVal.venderId
          newVal.additional.storeId = newVal.storeId
        }
        this.configs = newVal
        if (newVal.additional.promotionList && newVal.additional.promotionList.length) {
          this.items = newVal.additional.promotionList.map(val => val.subTypeName)
        } else {
          this.items = []
        }
        // this.items = ['adsfadsfadsfe','32442432','32442432','32442432']
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
    this.$bus.$on(`rest_${sku}_count`, this.handleRestCout)
  },
  beforeDestroy() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
    // 清除定时器以避免内存泄漏
    if (this.clearInterval) {
      this.clearInterval()
    }
  },
  methods: {
    handleRestCout(count) {
      this.$nextTick(() => {
        this.$set(this.configs, "addCartCount", count)
      })
    },
    async handleAddClick(item) {
      if (noAddressCheck()) {
        openNoAddressPop()
        return
      }

      trackAddToCart(item)
      const [error, data, wareList] = await handleAddToCartV2({
        // TODO storeId
        venderId: this.configs.venderId,
        storeId: this.configs.storeId || this.commonReqParams.storeId,
        wares: [{ sku: item.additional.sku || item.additional.skuId, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (data) {
        const res = data
        this.$set(this.configs, "addCartCount", 1)
        const sku = item.additional.sku || item.additional.skuId
        const Obj = wareList.find(item => item.sku === sku) || {}
        this.$set(this.configs, "stock", Obj.stock)
        // 同步相同sku商品加购数量
        this.$bus.$emit(`rest_${sku}_count`, 1)
        // omnichat fun
        await omnichatAddToCart([
          {
            // id: this.baseInfo.rfId,
            id: item.additional.sku || item.additional.skuId,
            name: item.additional.name,
            brand: item.brandName || "",
            category: item.categoryName || "",
            variant: "",
            quantity: 1,
            price: this.pageFrom ? item.additional.promotionPrice / 100 : item.additional.promotionPrice
          }
        ])
        this.intervalChange({ ...item, addCartCount: 1 })
      } else {
        this.$set(this.configs, "addCartCount", 0)
        console.log("加购失败", error)
        if (error && error.code == "44999") {
          openNoAddressPop()
        }
      }
    },
    // 输入框激活清除定时器
    handleFocus() {
      if (this.clearInterval) {
        this.clearInterval()
      }
    },
    // 失焦激活定时器
    handleBlur(count, item) {
      this.intervalChange({ ...item, addCartCount: count })
    },
    handleNumChange(count, item) {
      handleChangeCartNumber(count, this.configs.addCartCount, item)
      const sku = item.additional.sku || item.additional.skuId
      const cocunt = count <= 0 ? 0 : count
      // 同步相同sku商品加购数量
      this.$bus.$emit(`rest_${sku}_count`, cocunt)
      if (count > 0) {
        this.intervalChange({ ...item, addCartCount: count })
      } else {
        if (this.clearInterval) {
          this.clearInterval()
          this.$emit(`goodsNummberShow`, { ...item, goodsNummberShow: false, addCartCount: 0 })
        }
      }
    },

    intervalChange(item) {
      const goodsItem = { ...item, goodsNummberShow: true }
      // 清理之前的定时器（如果有）
      if (this.clearInterval) {
        this.clearInterval()
      }
      console.log(goodsItem, "goodsItemgoodsItem")

      // 启动新的定时器
      this.clearInterval = this.startCountdown(3, goodsItem)
    },
    // 定时器控制按钮的显示与隐藏
    startCountdown(seconds, goodsItem) {
      const that = this
      let countdown = seconds
      function update() {
        countdown--
        if (countdown < 0) {
          clearInterval(interval)
          that.$emit(`goodsNummberShow`, goodsItem)
        }
      }
      update() // 立即执行一次
      const interval = setInterval(update, 1000)
      // 返回一个清理函数，以便在需要时清除定时器
      return () => clearInterval(interval)
    },

    addCartBtn(item) {
      // 当有商品的时候，点击显示加减商品按钮
      this.$emit(`goodsNummberShow`, { ...item, goodsNummberShow: false })
      // 同时启动3秒定时器
      this.intervalChange(item)
    },

    trackSelectItem,
    getStockMax,
    priceFormatOther
  }
}
